import { useCallback, useContext } from 'react'
import { useSelector } from 'react-redux'

import {
  AppLocationContext,
  AppLocationFragment,
  MENU_TAB,
  TOPIC_VIEW,
} from '../../pages/admin/app_location_provider'
import { getCurrentHandle } from '../../reduxes/slices/current/selectors'
import { isLiveChatApp } from '../../reduxes/slices/live_chat_app/selectors'
import { getHandlesIndexedByMemberId } from '../../reduxes/slices/members/selectors'
import { getRoutesWithoutPrefill } from '../../reduxes/slices/routes/selectors'
import { useSelectorDelegateStore } from '../../reduxes/stores/root_store/hooks'
import { useIsContactInLatest } from '../use_is_contact_in_latest'

type Options = {
  navToNewDM: boolean
}

export const useNavToDirectChat = () => {
  const { appLocation, appLocationCache, setAppLocation } =
    useContext(AppLocationContext)
  const currentHandle = useSelector(getCurrentHandle)
  const routes: any = useSelectorDelegateStore(getRoutesWithoutPrefill)
  const directChatsPath = routes.admin_app_direct_chats_selected.path
  const isContactInLatest = useIsContactInLatest()
  const handleLookup = useSelectorDelegateStore(getHandlesIndexedByMemberId)
  const liveChatApp = useSelectorDelegateStore(isLiveChatApp)

  return useCallback(
    (
      directChatHandle,
      topicId = null,
      options: AppLocationFragment = {},
      { navToNewDM }: Options = { navToNewDM: false },
    ) => {
      const currentLocation = options.memberId
        ? appLocationCache[options.memberId]
        : appLocation
      let menuTab = currentLocation?.menuTab
      if (menuTab !== MENU_TAB.LATEST && menuTab !== MENU_TAB.DIRECT_CHATS) {
        menuTab = MENU_TAB.LATEST
      }
      if (menuTab === MENU_TAB.LATEST && !navToNewDM) {
        menuTab = isContactInLatest(directChatHandle)
          ? MENU_TAB.LATEST
          : MENU_TAB.DIRECT_CHATS
      }
      const handle = options.memberId
        ? handleLookup[options.memberId]
        : currentHandle
      return setAppLocation({
        url: directChatsPath
          .replace(':current_handle', handle)
          .replace(':handle', directChatHandle),
        directChatHandle: directChatHandle,
        topicId,
        topicView: TOPIC_VIEW.CHAT_VIEW,
        menuTab: menuTab,
        ...(!liveChatApp && { welcomeMessageId: null }),
        videoCollectionId: null,
        ...options,
      })
    },
    [
      appLocation,
      appLocationCache,
      currentHandle,
      directChatsPath,
      handleLookup,
      isContactInLatest,
      liveChatApp,
      setAppLocation,
    ],
  )
}
